import { Component, OnInit, ViewChild } from '@angular/core';
import swal from 'sweetalert2';  
import { AuthService } from 'src/app/services/auth.service';
import { Router } from '@angular/router';

@Component({
  selector: 'app-wscli',
  templateUrl: './wscli.component.html',
  styleUrls: ['./wscli.component.scss']
})
export class WscliComponent implements OnInit {
  @ViewChild('cpa',null) cpa;
  @ViewChild('cht',null) cht;
  @ViewChild('chtd',null) chtd;
  
  constructor(public authService: AuthService,public router:Router) { }
  idcliente=0;
  ngOnInit() {
    this.idcliente=Number(localStorage.getItem("id_cliente"));  
    this.usuario=Number(localStorage.getItem("usuario"));
    this.get_org();
    this.ls_ws();
  }
  bndGuardarht=false;
  bndGuardarhtd=false;
  bndmnugral=true;
  oculta_menu(){
    console.log("-");
    if(this.bndmnugral==true){
      this.bndmnugral=false;
    }else{
      this.bndmnugral=true;
    }
    console.log(this.bndmnugral);
  }
  _go(a){
    //localStorage.setItem("menu_","1");    
    this.router.navigate([a]);
  }
  loading;
  ht=[];
  id_ht=0;
  fmt_ht_pdf_(itm){
    localStorage.setItem("tpdf_ht","1")
    this.id_ht=itm.id_ht;
    this.fmt_ht_pdf(); 
  }
  fmt_ht_pdf2_(itm){
    localStorage.setItem("tpdf_ht","2")
    this.id_ht=itm.id_ht;
    this.fmt_ht_pdf(); 
  }
  bus_ht(){
    this.ht=[]; 
    for(var i=0;i<this.ht_aux.length;i++){
      if(this.ht_aux[i].org==null){
        if( this.ht_aux[i].raci.toLowerCase().includes(this.tx_ht_.toLowerCase())
        || this.ht_aux[i].tarea.toLowerCase().includes(this.tx_ht_.toLowerCase())
        || this.ht_aux[i].ht.toLowerCase().includes(this.tx_ht_.toLowerCase())){
          this.ht.push(this.ht_aux[i])
        }
      }else{
        if( this.ht_aux[i].org.toLowerCase().includes(this.tx_ht_.toLowerCase()) 
        || this.ht_aux[i].raci.toLowerCase().includes(this.tx_ht_.toLowerCase())
        || this.ht_aux[i].tarea.toLowerCase().includes(this.tx_ht_.toLowerCase())
        || this.ht_aux[i].ht.toLowerCase().includes(this.tx_ht_.toLowerCase())){
          this.ht.push(this.ht_aux[i])
        }
      }      
    }
  }
  tx_ht_=""
  limpia_nombre(){
    this.ht=this.ht_aux;
    this.tx_ht_=""
  }
  fmt_ht_pdf(){    
    localStorage.setItem("t_ht","P");
    localStorage.setItem("id_ht",this.id_ht.toString());
    this.router.navigate([]).then(result => {  window.open('./#/fmtht', '_blank'); });     
  }
  org_;
  ch(i,id){
    console.log("cambio "+i);
    console.log("cambio "+id);
    console.log(i);
    let postData={
      id:id,
      codigo:i
     }
     
     console.log(postData)
     this.authService.service("/api/upd_ht_codigo",postData)
       .then(
         data => {
           this.loading=false;
           var dat = JSON.stringify(data);
           var res = JSON.parse(dat); 
           swal.fire('¡ok', '', 'success');
         },
         error => {
             var de= JSON.stringify(error);
             var di = JSON.parse(de)
             this.loading=false;
             swal.fire('¡API incorrecta..! get_ht_cli', '', 'error');
       });
  }
  ht_aux=[];
  ls_ws(){
    let postData={
      id_cliente:localStorage.getItem("cliente")
     }
     console.log(postData)
     this.authService.service("/api/get_ht_cli",postData)
       .then(
         data => {
           this.loading=false;
           var dat = JSON.stringify(data);
           var res = JSON.parse(dat); 
           this.ht=res;
           this.ht_aux=res;
           console.log(res);
         },
         error => {
             var de= JSON.stringify(error);
             var di = JSON.parse(de)
             this.loading=false;
             swal.fire('¡API incorrecta..! get_ht_cli', '', 'error');
       });
  }

  a_:0;
  p_:0;
  msg_ht="";
  bnd_htp=true;
  ht_list;
  bnd_list_ht=false;
  _ht(itm,p,a){    

    this.bnd_htl=false;
    this.bnd_ht=false;
    this.bnd_list_ht=true;

    this.bnd_htp=false;
    this.msg_ht=itm.proceso;
    this.p_=itm.p;
    this.a_=itm.a;
    //console.log(p+"::"+a)
    this.loading=false
    
    //this.cpa.nativeElement.click();
    this.ls_ht();
    this.bnd_list_ht=true;
    //this.router.navigate([]).then(result => {  window.open('./ht', '_blank'); });  
    
  }


  ls_ht(){
    let postData = {
      a_:this.a_,
      p_:this.p_
    } 
      //console.log(postData);
      this.ht_list=[];
      this.authService.service("/api/get_ht",postData)
      .then(
          data => {
            var dat = JSON.stringify(data);
            var res = JSON.parse(dat);
            var tot=res.length;
            //console.log(res);
            if(tot==0){
              this.msg_ht="No result data";
            }
            for(var i=0;i<res.length;i++){
              this.ht_list.push({n:tot,
                id:res[i].id,
                usuario_nombre:res[i].usuario_nombre,
                nombre:res[i].nombre,
                codigo:res[i].codigo,
                fecha:res[i].fecha,
                tiempo:res[i].Tiempo
              });
              tot=tot-1;
            }
            //this.ht_list=data;
            //console.log(data)
          },
          error => {
              var de= JSON.stringify(error);
              var di = JSON.parse(de)
              swal.fire('¡API incorrecta! exp', '', 'error');
          });   
  }
  
  bnd_ht=false;
  bnd_htl=false;
  togle_ht_list(){
    this.bnd_htl=false;
    if(this.bnd_list_ht==true){
      this.bnd_list_ht=false
    }else{
      this.bnd_list_ht=true;
      this.bnd_ht=false;
    }
  }
  img(i){
    //.log(i)
     if(i===null){
       return "image-none.jpg"
     }
     return i;
   }
  ht_name="";
  codigo_ht="";
  fecha_ht="";
  rev_ht=0;
  ht_usuario;
  v_ht(itm){
    this.bnd_htl=true;
    this.bnd_ht=true;
    this.bnd_list_ht=false;
    this.id_ht=itm.id;
    this.ht_name=itm.nombre;
    this.fecha_ht=itm.fecha;
    this.codigo_ht=itm.codigo;
    this.rev_ht=itm.n;
    this.ht_usuario=itm.usuario_nombre;
    this.ls_ht_det();
  }
  htd;
  tiempo_ht=0;
  ls_ht_det(){
    this.htd=[];
    let postData = {
      id:this.id_ht
    } 
    console.log(postData);
    this.authService.service("/api/get_ht_det",postData)
    .then(
        data => {
          var dat = JSON.stringify(data);
          var res = JSON.parse(dat);
          this.tiempo_ht=0;
          this.htd=[];
          for(var i=0 ;i<res.length;i++){
            var bnd_m=false;
            var bnd_im2=false;            
            var bnd_im3=false;
            var bnd_im4=false;
            if(res[i].img1!=null){bnd_im2=true;bnd_m=true}
            if(res[i].img2!=null){bnd_im3=true;bnd_m=true}
            if(res[i].img3!=null){bnd_im4=true;bnd_m=true}
            var tt=0;
            try {
              tt=Number(res[i].tiempo);  
            } catch (error) {              
            }
            this.tiempo_ht=this.tiempo_ht+tt;
            this.htd.push({n:i+1,
                id:res[i].id,
                simbolo1:res[i].simbolo1,
                simbolo2:res[i].simbolo2,
                simbolo3:res[i].simbolo3,
                simbolo4:res[i].simbolo4,
                principal:res[i].principal,
                importante:res[i].importante,
                razon:res[i].razon,
                tiempo:res[i].tiempo,
                img1:this.img(res[i].img1),
                img2:this.img(res[i].img2),
                img3:this.img(res[i].img3),
                img4:this.img(res[i].img4),
                bnd_im2:bnd_im2,
                bnd_im3:bnd_im3,
                bnd_im4:bnd_im4,
                bnd_m:bnd_m,
                url:res[i].url,
                role:res[i].role,
                rolecard:res[i].rolecard,
                val:res[i].valor

              });
          }
          //console.log(data)
        },
        error => {
            var de= JSON.stringify(error);
            var di = JSON.parse(de)
            swal.fire('¡API incorrecta! exp', '', 'error');
        });
  }
  bndSaveht=false;
  edt_ht(itm){
    this.bndSaveht=false;
    //console.log(itm);
    this.id_ht=itm.id;
    this.ht_name=itm.nombre;
    this.fecha_ht=itm.fecha.substring(0,10);
    this.codigo_ht=itm.codigo;
  }

  ls_htp(){
    let postData = {
      p_:this.p_
    } 
      //console.log(postData);
      this.ht_list=[];
      this.authService.service("/api/get_ht_p",postData)
      .then(
          data => {
            var dat = JSON.stringify(data);
            var res = JSON.parse(dat);
            var tot=res.length;
            //console.log(res);
            if(tot==0){
              this.msg_ht="No result data";
            }
            for(var i=0;i<res.length;i++){
              this.ht_list.push({n:tot,
                id:res[i].id,
                usuario_nombre:res[i].usuario_nombre,
                nombre:res[i].nombre,
                codigo:res[i].codigo,
                fecha:res[i].fecha,
                tiempo:res[i].Tiempo
              });
              tot=tot-1;
            }
            //this.ht_list=data;
            //console.log(data)
          },
          error => {
              var de= JSON.stringify(error);
              var di = JSON.parse(de)
              swal.fire('¡API incorrecta! exp', '', 'error');
          });   
  }
  usuario;
  gda_ht(){
    let postData = {
      nombre:this.ht_name,
      fecha:this.fecha_ht,
      codigo:this.codigo_ht,
      usuario:this.usuario,
      a:this.a_,
      p:this.p_
    }
    console.log("gda_ht"); 
    console.log(postData);
      this.authService.service("/api/ins_ht",postData)
      .then(
          data => {
            var dat = JSON.stringify(data);
            var res = JSON.parse(dat);
            if(this.bnd_htp){this.ls_htp();}
            else{this.ls_ht();}
            this.msg_ht="";
            //this.bnd_list_ht=true;
            //console.log(data)
            this.cht.nativeElement.click();
          },
          error => {
              var de= JSON.stringify(error);
              var di = JSON.parse(de)
              swal.fire('¡API incorrecta! exp', '', 'error');
          });   
  }
  dupl_ht(itm){
    let postData = {
      id:itm.id
    } 
    this.authService.service("/api/dupl_ht",postData)
    .then(
        data => {
          var dat = JSON.stringify(data);
          var res = JSON.parse(dat);
          this.ls_ht();
        },
        error => {
            var de= JSON.stringify(error);
            var di = JSON.parse(de)
            swal.fire('¡API incorrecta! exp', '', 'error');
        });
  }
  del_ht(itm){
    if(confirm("Confirm to delete this record?")==false)return;
    let postData = {
      id:itm.id
    } 
    this.authService.service("/api/del_ht",postData)
    .then(
        data => {
          var dat = JSON.stringify(data);
          var res = JSON.parse(dat);
          //console.log(data)
          this.ls_ht(); 
        },
        error => {
            var de= JSON.stringify(error);
            var di = JSON.parse(de)
            swal.fire('¡API incorrecta! exp', '', 'error');
        });
  }
  fmt_ht_pdf_1(itm){
    this.id_ht=itm.id;
    this.fmt_ht_pdf(); 
  }
  htdet={
    id:0,
    num:0,
    tipo:"",
    simbolo1:0,
    simbolo2:0,
    simbolo3:0,
    simbolo4:0,
    principal:"",
    importante:"",
    razon:"",
    tiempo:0,
    role:0,
    im1:"",im2:"",im3:"",im4:"",url:""
  };
  bndSavehtd=false;
  nvo_htd(){    
    this.bndGuardarhtd=true
    //this.htd=[];
    this.htdet.simbolo1=0,
    this.htdet.simbolo2=0,
    this.htdet.simbolo3=0,
    this.htdet.simbolo4=0,
    this.htdet.tipo="H";
    this.htdet.principal="";
    this.htdet.importante="";
    this.htdet.razon="";
    this.htdet.tiempo=0;
    this.htdet.im1="";
    this.htdet.im2="";
    this.htdet.im3="";
    this.htdet.im4="";
    this.htdet.url="";
    this.htdet.role=0;
    //this.bnd_list_ht=true
    this.bndSavehtd=true;
  }
  gda_htd(){
    let postData = {
      id_hoja_trabajo:this.id_ht,
      simbolo1:Number(this.htdet.simbolo1),
      simbolo2:Number(this.htdet.simbolo2),
      simbolo3:Number(this.htdet.simbolo3),
      simbolo4:Number(this.htdet.simbolo4),
      principal:this.htdet.principal,
      importante:this.htdet.importante,
      razon:this.htdet.razon,
      tipo:this.htdet.tipo,
      tiempo:this.htdet.tiempo,
      url:this.htdet.url,
      role:this.htdet.role
    } 
    console.log("gda_htd");
    console.log(postData);
    this.authService.service("/api/ins_ht_det",postData)
    .then(
        data => {
          var dat = JSON.stringify(data);
          var res = JSON.parse(dat);
          //console.log(data)
          
          this.ls_ht_det();
          this.chtd.nativeElement.click();
        },
        error => {
            var de= JSON.stringify(error);
            var di = JSON.parse(de)
            swal.fire('¡API incorrecta! exp', '', 'error');
        });
  }
  upd_htd(){
    let postData = {
      id:this.htdet.id,
      simbolo1:Number(this.htdet.simbolo1),
      simbolo2:Number(this.htdet.simbolo2),
      simbolo3:Number(this.htdet.simbolo3),
      simbolo4:Number(this.htdet.simbolo4),
      principal:this.htdet.principal,
      importante:this.htdet.importante,
      razon:this.htdet.razon,
      tipo:this.htdet.tipo,
      tiempo:this.htdet.tiempo,
      url:this.htdet.url,
      role:this.htdet.role
    } 
    //console.log(postData);
    this.authService.service("/api/upd_ht_det",postData)
    .then(
        data => {
          var dat = JSON.stringify(data);
          var res = JSON.parse(dat);
          //console.log(data)
          this.ls_ht_det();
          this.chtd.nativeElement.click();
        },
        error => {
            var de= JSON.stringify(error);
            var di = JSON.parse(de)
            swal.fire('¡API incorrecta! exp', '', 'error');
        });
  }
  edt_htd(itm){
    ///console.log(itm);
    this.bndGuardarhtd=false;
    this.htdet.id=itm.id;
    this.htdet.simbolo1=itm.simbolo1;
    this.htdet.simbolo2=itm.simbolo2;
    this.htdet.simbolo3=itm.simbolo3;
    this.htdet.simbolo4=itm.simbolo4;
    this.htdet.tipo=itm.tipo;
    this.htdet.principal=itm.principal;
    this.htdet.importante=itm.importante;
    this.htdet.razon=itm.razon;
    this.htdet.tiempo=itm.tiempo;
    this.htdet.im1=itm.im1;
    this.htdet.im2=itm.im2;
    this.htdet.im3=itm.im3;
    this.htdet.im4=itm.im4;
    this.htdet.url=itm.url;
    this.htdet.role=itm.role;
    this.bndSavehtd=false;
  }
  del_htd(itm){
    if(confirm("Desea eliminar el registro")==false)return;
    let postData = {
      id:itm.id
    } 
    this.authService.service("/api/del_ht_det",postData)
    .then(
        data => {
          var dat = JSON.stringify(data);
          var res = JSON.parse(dat);
          //console.log(data)
          
          this.ls_ht_det();
        },
        error => {
            var de= JSON.stringify(error);
            var di = JSON.parse(de)
            swal.fire('¡API incorrecta! exp', '', 'error');
        });    
  }

  org2_:any;
  org:any;
  get_org(){
    this.org2_=[];
    this.authService.service("/api/get_org_role",{ id_cliente:localStorage.getItem("id_cliente")} )
    .then(
        data => {
          var dat = JSON.stringify(data);
          var res = JSON.parse(dat);  
            this.org=data; 
            
            //this.org2_=this.authService._org_jerarquizacion(data);
            for(var i=0;i<this.org.length;i++){
              if(this.org[i].organo!='A')
              this.org2_.push(this.org[i])
            }              
              
        },
        error => {
            var de= JSON.stringify(error);
            var di = JSON.parse(de)
            swal.fire('¡API incorrecta!', '', 'error');
        });  

    /*let postData = {
      id_cliente:localStorage.getItem("id_cliente")
    } 
      //console.log(postData);
      this.authService.service("/api/get_org",postData)
      .then(
          data => {
            var dat = JSON.stringify(data);
            var res = JSON.parse(dat);
            this.org=data;
            this.org_=this.authService.org_head(this.org);
            //console.log(this.org_);
          },
          error => {
              var de= JSON.stringify(error);
              var di = JSON.parse(de)
              swal.fire('¡API incorrecta! exp', '', 'error');
          });   */
    }

}
